<template lang="html">
  <div class="section suggested-products">
    <h2 class="bgap-48">Products to Consider</h2>

    <div v-if="loading">
      <div class="gap-3x" />
      <Spinner />
      <div class="gap-3x" />
    </div>

    <transition name="fade">
      <div v-if="!loading" class="body-17 gray">
        <div :key="product.product" v-for="product in suggestedProducts">
          <div class="section-field flex-box wrap" >
            <h3 class="black pull-left bgap-24">
              {{product.product}}
            </h3>
            <div class="field pull-right">
              <div class="body-16">{{product.description}}</div>
              <a class="learn-more" :href="product.link" target="_blank">
                <span class="body-14 link-purple">Learn more</span>
                <i class="si-icon si-caret_right purple"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import Spinner from 'src/components/common/Spinner.vue'
import EventBus from 'src/components/EventBus.js'
export default {
  components: { Spinner },
  methods: {
    assignData(data) {
      this.suggestedProducts = data.suggested_products
      this.loading = false
    }
  },
  data() {
    return {
      suggestedProducts: [],
      loading: true,
    }
  },
  created() {
    EventBus.$on('user-fetched', this.assignData)
  },
  beforeDestroy() {
    EventBus.$off('user-fetched', this.assignData)
  },
}
</script>

<style lang="scss" scoped>
.suggested-products {
  .section-field {
    border-top: 1px solid var(--gray-divider);
  }

  a.learn-more {
    span.link-purple {
      font-weight: 500;
    }
    
    .si-icon {
      font-weight: 800;
      display: inline-block;
      font-size: 12px;
      line-height: 28px;
      vertical-align: bottom;
      height: 24px;
    }

    &:hover {
      text-decoration: none;

      span.link-purple {
        text-decoration: underline;
      }
    }
  }
}

</style>
